import { Injectable } from '@angular/core';

import { Action, Reducer, Store } from '@olympus/ngx-shared';
import { FileBrowserModalComponent } from 'shared-business-angular/desktop-file-browser';
import { DialogService } from 'shared-modules-angular/dialog';

import { DPUActionType } from '../dpu/dpu.reducer';
import { FileActionType } from './file-action-type.enum';

@Injectable({
  providedIn: 'root',
})
export class FileDialogReducer implements Reducer {
  constructor(
    private readonly _store: Store,
    private readonly _dialogService: DialogService,
  ) { }

  public reduce(action: Action): void {
    switch (action.type) {
      case FileActionType.OPEN_FILE_DIALOG:
        this._dialogService.open(
          FileBrowserModalComponent,
          {
            height: FileBrowserModalComponent.HEIGHT,
            width: FileBrowserModalComponent.WIDTH,
            disableClose: true,
          },
        );

        break;

      case FileActionType.AFTER_CLOSE_FILE_DIALOG:
        this._store.dispatch({
          type: DPUActionType.FILE_SELECTED,
          payload: action.payload,
        });

        break;

      default:
        break;
    }
  }
}
